













































import { Ref, Prop, Vue, Component } from "vue-property-decorator";

// Model Class
import { UIModel } from "./../../UIModel";
import { FrontendBIM360Hub } from '../../model/frontend/FrontendBIM360Hub';
import { FrontendBIM360Project } from '@/model/frontend/FrontendBIM360Project';

@Component({
	components: {},
})
export default class App extends Vue {
    // Props
    @Prop({ required: true }) public model!: UIModel;


    // Methods
    public async chooseHub(hub: FrontendBIM360Hub): Promise<void> {
        await this.model.selectHub(hub);
        // if (this.model.selectedProject !== null && this.$route.path != "/issues") {
        //     this.$router.push("/issues");
        // }
    }

    // Methods
    public async chooseProject(project: FrontendBIM360Project): Promise<void> {
        this.model.selectProject(project);
        // if (this.$route.path != "/issues") {
        //     this.$router.push("/issues");
        // }
    }
}
